export const CMA_SCOPE_KEY = "cma";
